import { Route, Routes, useLocation } from "react-router-dom";
import { Box } from "@mui/material";
import { useSession } from "./context/SessionContext";
import Layout from "./components/Layout";
import ErrorBoundary from "./components/ErrorBoundary";
import ErrorPage from "./components/ErrorPage";
import { ErrorNote, LoadingBlock } from "./components/Feedback";
import LoginPage from "./pages/LoginPage";
import PendingApprovalPage from "./pages/PendingApprovalPage";
import DashboardPage from "./pages/DashboardPage";
import AiInventoryPage from "./pages/AiInventoryPage";
import AssessmentPage from "./pages/AssessmentPage";
import FrameworksPage from "./pages/FrameworksPage";
import EvidencePage from "./pages/EvidencePage";
import RisksPage from "./pages/RisksPage";
import PoliciesPage from "./pages/PoliciesPage";
import AuditsPage from "./pages/AuditsPage";
import VendorsPage from "./pages/VendorsPage";
import UsersPage from "./pages/UsersPage";

export default function App() {
  const { authUser, authLoading, ready, meError, pending } = useSession();
  const location = useLocation();

  if (authLoading) return <LoadingBlock label="Checking your session…" />;
  if (!authUser) return <LoginPage />;
  if (pending) return <PendingApprovalPage />;
  if (meError) {
    return (
      <Box sx={{ p: 4, maxWidth: 560, mx: "auto" }}>
        <ErrorNote error={meError} />
      </Box>
    );
  }
  if (!ready) return <LoadingBlock label="Loading your workspace…" />;

  return (
    <ErrorBoundary resetKey={location.pathname}>
    <Routes>
      <Route element={<Layout />}>
        <Route index element={<DashboardPage />} />
        <Route path="ai-inventory" element={<AiInventoryPage />} />
        <Route path="ai-inventory/:id/assessment" element={<AssessmentPage />} />
        <Route path="frameworks" element={<FrameworksPage />} />
        <Route path="evidence" element={<EvidencePage />} />
        <Route path="risks" element={<RisksPage />} />
        <Route path="policies" element={<PoliciesPage />} />
        <Route path="audits" element={<AuditsPage />} />
        <Route path="vendors" element={<VendorsPage />} />
        <Route path="admin/users" element={<UsersPage />} />
        <Route
          path="*"
          element={<ErrorPage title="Page not found" message="That address doesn't match anything here. Use the button below to get back on track." />}
        />
      </Route>
    </Routes>
    </ErrorBoundary>
  );
}
